import { useAppSelector } from './global';

const useIsDarkTheme = () => {
  const themeFromRedux = useAppSelector(state => state.user.theme);

  return themeFromRedux === 'dark';
};

export default useIsDarkTheme;
